var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgManage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "#888888",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.01,
    width: 24,
    height: 24,
    fill: ""
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 11.8299L3 8.35986V16.0899C3.00888 16.748 3.3991 17.3412 4 17.6099L11.19 20.9999H11.25V11.8299Z",
    fill: ""
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0002 10.4998L20.5102 6.92976C20.367 6.77064 20.1937 6.64149 20.0002 6.54976L12.8002 3.17976C12.2938 2.94008 11.7066 2.94008 11.2002 3.17976L4.00023 6.54976C3.8068 6.64149 3.63346 6.77064 3.49023 6.92976L12.0002 10.4998Z",
    fill: ""
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 11.8299V20.9999H12.8L20 17.6099C20.5977 17.3427 20.9873 16.7544 21 16.0999V8.35986L12.75 11.8299Z",
    fill: ""
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManage);
export default __webpack_public_path__ + "static/media/manage.f1009b040b720f328718bd607caf5c99.svg";
export { ForwardRef as ReactComponent };